import React from 'react';
import styled from '@emotion/styled';

import { mq, text, green01 } from '../../_style';

import TextBlock from './textBlock';
import Text from '../atoms/text';
import Image from '../atoms/image';

const Header = styled.header`
  ${mq.pc} {
    padding-bottom: 90px;
  }
  ${mq.sp} {
    padding-bottom: 60px;
  }
`;
const HeaderHeading = styled.h1`
  color: ${green01};
`;
const HeaderHeadingSubText = styled.span`
  display: block;
  font-weight: bold;
  ${text('18px', 1.4)}
  ${mq.pc} {
    padding-bottom: 30px;
  }
  ${mq.sp} {
    padding-bottom: 20px;
  }
`;
const HeaderHeadingText = styled.span`
  display: block;
  padding-bottom: 30px;
  ${mq.pc} {
    ${text('36px', (58/36))}
  }
  ${mq.sp} {
    ${text('31px', (46/31))}
  }
`;
const Img = styled.figure`
  header & {
    ${mq.sp} {
      margin: 0 -20px;
    }
  }
`;

const ArticleHeader = (props) => {
  return(
    <Header>
      <HeaderHeading>
        {props.sub && <HeaderHeadingSubText>{props.sub}</HeaderHeadingSubText>}
        <HeaderHeadingText>{props.title}</HeaderHeadingText>
      </HeaderHeading>
      <TextBlock>
        <Text>{props.children}</Text>
        {props.filename && <Img><Image filename={props.filename} alt=""></Image></Img>}
      </TextBlock>
    </Header>
  );
};
export default ArticleHeader;
